<template>
  <div class="modelcover" @click="cancelLogin">
    <div class="sigin" @click.stop="">
    			<div class="modal">
    				<div class="title flex">
    					用户登录
    					<span class="flex1"></span>
    					<img src="../assets/img/codelogin.png" @click="handleCodeLogin()" style="cursor: pointer;">
    				</div>
    				<div class="flex list" style="margin-top: 50px;">
    					<img src="../assets/img/usericon.png" width="19" height="20">
    					<input type="tel" name="" id="" value="" placeholder="请输入手机号" v-model="phone" />
    				</div>
    <!-- 				<div class="flex list">
    					<img src="../img/codeicon.png" width="19" height="20" >
    					<input type="tel" name="" id="" value="" placeholder="请输入短信验证码" class="flex1" />
    					<span style="color: #4fa7ff;">获取验证码</span>
    				</div> -->
    				<div class="flex list">
    					<img src="../assets/img/passwordicon.png" width="18" height="20" >
    					<input type="password" name="" id="" value="" placeholder="请输入密码" v-model="password" />
    				</div>
    				<div class="flex" style="justify-content: space-between;margin-top: 15px;">
    					<span style="color: #4fa7ff;cursor: pointer;" @click="handleReset()">忘记密码?</span>
    					<span style="color: #4fa7ff;cursor: pointer;" @click="handleSigin()">立即注册</span>
    				</div>
    				<div class="btn" style="cursor: pointer;" @click="handleLogin()" >
    					登录
    				</div>
    				<div class="text-center"  style="margin-top: 10px;font-size: 18px;color: #999;cursor: pointer;" @click="cancelLogin">
    					取消
    				</div>
    			</div>
    	</div>
  </div>
</template>

<script>

  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
          showLogin:false,
          phone:'',
          password:'',
          loginType:2
      }
    },
    methods:{
      handleReset(){
        this.$emit('handleReset')
      },
      handleSigin(){
        this.$emit('handlesign')
      },
      cancelLogin(){
        this.$emit('cancellogin')
      },
      handleCodeLogin(){
        console.log(55)
        this.$emit('handleCodeLogin')
      },
      handleLogin(){
        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        if(this.password==''){
          alert('请输入登录密码');

          return ;
        }
         this.$axios.defaults.headers.common["Authorization"] = ''
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('password',this.password);
            data.append('loginType',2);
        this.$axios.post(this.$common.login_url,data).then((res)=>{
              console.log(res)
              if(res.data.code==1){
                window.sessionStorage.token=res.data.data;
                this.phone='';
                this.password=''
                this.$emit('pwdLogined')
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    }
  }
</script>

<style scoped>
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
        z-index: 1988;
  }
  .sigin {
  	width: 390px;
  	    height: 430px;
  	    border-radius: 10px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
  }
  .sigin .title {
  	font-size: 24px;
  }
  .sigin input {
  	border: none;
  	line-height: 40px;
  	outline: none;
  	text-indent: 15px;
  	font-size: 16px;
  }
  .sigin .list {
  	border-bottom: 1px solid #eee;
  	align-items: center;
  	margin-top: 15px;
  }
  .sigin .btn {
  	height: 50px;
  	text-align: center;
  	line-height: 50px;
  	color: #fff;
  	background-color: #4fa7ff;
  	border-radius: 4px;
  	margin-top: 80px;
  	font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue